export const version = "bytes/5.0.8";
//# sourceMappingURL=_version.js.map